import * as React from 'react';
import './UploadFontList.scss';
import { t } from '@moovly/i18n';
import { FontItem } from '../../store/settings.store';
import UploadFontListItem from './UploadFontListItem';
import { Table, TableBody, TableCol, TableHeader, TableRow } from '../../../../components/Table';

interface UploadFontListProps {
  fonts: FontItem[];
  onUpdateItem: (index: number, property: string, value: string) => void;
  onDelete: (index: number) => void;
}

const UploadFontList: React.FC<UploadFontListProps> = ({ fonts, onUpdateItem, onDelete }) => (
  <div className="UploadFontList mt-4">
    <Table>
      <TableHeader>
        <TableRow>
          <TableCol>{t('fonts.create.upload.table.fileName')}</TableCol>
          <TableCol>{t('fonts.create.upload.table.weight')}</TableCol>
          <TableCol>{t('fonts.create.upload.table.style')}</TableCol>
          <td />
        </TableRow>
      </TableHeader>
      <TableBody>
        {!fonts.length && (
          <TableRow>
            <TableCol colSpan={4} className="text-center pt-4 pb-4">
              {t('fonts.create.upload.table.none')}
            </TableCol>
          </TableRow>
        )}
        {fonts.map((font, index) => (
          <UploadFontListItem
            onDelete={onDelete}
            key={`${font.font_file.name}_${index}`}
            id={index}
            fontItem={font}
            onUpdate={onUpdateItem}
          />
        ))}
      </TableBody>
    </Table>
  </div>
);
export default UploadFontList;
